import i18n from 'i18n';
import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';

export default [
  {
    gridXs: 4,
    stateKey: 'advisor_type',
    label: i18n.t('TYPE_KEY'),
    isSelect: true,
    options: [
      { value: 'all', label: i18n.t('ALL_KEY') },
      {
        value: 'empty_instances_saturday',
        label: i18n.t('EMPTY_INSTANCES_SATURDAY_KEY'),
      },
      {
        value: 'empty_instances_sunday',
        label: i18n.t('EMPTY_INSTANCES_SUNDAY_KEY'),
      },
      {
        value: 'empty_instances_any_day',
        label: i18n.t('EMPTY_INSTANCES_ANY_DAY_KEY'),
      },
      {
        value: 'dynamic_advisor_weekday_start',
        label: i18n.t('DYNAMIC_ADVISOR_WEEKDAY_START_KEY'),
      },
      {
        value: 'dynamic_advisor_weekday_end',
        label: i18n.t('DYNAMIC_ADVISOR_WEEKDAY_END_KEY'),
      },
    ],
  },
  {
    gridXs: 4,
    stateKey: 'status',
    label: i18n.t('STATUS_KEY'),
    isSelect: true,
    options: [
      { value: 'all', label: i18n.t('ALL_KEY') },
      { value: 'pending', label: i18n.t('PENDING_KEY') },
      { value: 'applied', label: i18n.t('APPLIED_KEY') },
      {
        value: 'expired',
        label: i18n.t('DEPRECIATED_KEY'),
      },
      {
        value: 'ignored',
        label: i18n.t('IGNORED_KEY'),
      },
      {
        value: 'reverted',
        label: i18n.t('REVERTED_KEY'),
      },
    ],
  },
] as GenericFormItem[];
